import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WindowRef } from '../../windowHref';
var CoursetosessionComponent = /** @class */ (function () {
    function CoursetosessionComponent(router, winRef, route) {
        this.router = router;
        this.winRef = winRef;
        this.route = route;
        this.showSpinner = true;
        this.showOnlyOverlay = false;
        var url = winRef.nativeWindow.location.href;
        console.log('window url =' + url);
        url = url.replaceAll('course', 'session');
        console.log('new replaced url =' + url);
        var newURL = new URL(url);
        console.log(newURL.hash);
        window.location.replace(newURL.hash);
    }
    CoursetosessionComponent.prototype.ngOnInit = function () {
    };
    return CoursetosessionComponent;
}());
export { CoursetosessionComponent };
//# sourceMappingURL=coursetosession.component.js.map